const appConfig = {
    apiPrefix: 'https://mmf.moneymarket.mn/api',
    //apiPrefix: 'http://192.168.94.30:8000',
    contractAPI: 'https://mmf.moneymarket.mn',
    // apiPrefix: 'http://192.168.1.11:8000',
    // apiPrefix: 'http://exchange_backend/api',
    //apiPrefix: 'http://192.168.94.30:8000'
    // apiPrefix: 'http://exchange_backend/api',
    //apiPrefix: 'http://192.168.94.30:8000',
    authenticatedEntryPath: '/dashboard',
    unAuthenticatedEntryPath: '/sign-in',
    // expiredEntryPath: '/wallet/password',
    expiredEntryPath: '/reset-password',
    tourPath: '/',
    enableMock: false
}

export default appConfig
